import { Router } from '@angular/router';
import { AuthService } from './../services/auth.service';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-sigout-callback',
    templateUrl: 'auth-signout-callback.component.html',
    styleUrls: ['./auth-callback.component.css'],
    standalone: false
})
export class AuthSignoutCallbackComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit() {
    this.authService.completeLogout().then(response => {
      this.router.navigate(['/'], { replaceUrl: true });
    });
  }
}
